module.exports = __webpack_public_path__ + "assets/img/922941.b5225b6a.jpg";